import React from "react";

// Free CC0-licensed Unsplash mountain scene — served responsive
const MOUNTAIN =
  "https://images.unsplash.com/photo-1519681393784-d120267933ba?w=2400&q=80&auto=format&fit=crop";

const Background = () => {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
      {/* deep sky */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(1200px 600px at 20% -10%, #1a2246 0%, transparent 60%), radial-gradient(900px 500px at 90% 0%, #0d1a3a 0%, transparent 65%), linear-gradient(180deg, #04070f 0%, #060b1c 40%, #0a1330 100%)",
        }}
      />

      {/* stars */}
      <div
        className="absolute inset-0"
        style={{
          opacity: 0.9,
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='800' height='800'><g fill='white'><circle cx='40' cy='60' r='0.8'/><circle cx='120' cy='150' r='0.6'/><circle cx='250' cy='80' r='1'/><circle cx='400' cy='200' r='0.7'/><circle cx='560' cy='120' r='0.9'/><circle cx='680' cy='60' r='0.6'/><circle cx='750' cy='260' r='0.8'/><circle cx='90' cy='330' r='0.7'/><circle cx='200' cy='420' r='1.1'/><circle cx='330' cy='500' r='0.6'/><circle cx='470' cy='360' r='0.8'/><circle cx='620' cy='430' r='0.9'/><circle cx='720' cy='510' r='0.7'/><circle cx='150' cy='600' r='0.6'/><circle cx='290' cy='680' r='1'/><circle cx='430' cy='720' r='0.7'/><circle cx='570' cy='620' r='0.8'/><circle cx='690' cy='770' r='0.9'/></g></svg>\")",
          backgroundSize: "800px 800px",
        }}
      />

      {/* nebula blooms */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(600px 300px at 15% 25%, rgba(59,130,246,0.14), transparent 60%), radial-gradient(500px 260px at 85% 20%, rgba(147,51,234,0.10), transparent 60%)",
        }}
      />

      {/* mountains — fixed position, fills the entire viewport (no top/bottom gap) */}
      <div className="absolute inset-0">
        <div
          className="absolute inset-0 bg-no-repeat bg-cover bg-center"
          style={{
            backgroundImage: `url(${MOUNTAIN})`,
            filter: "brightness(0.55) saturate(0.9) hue-rotate(-8deg)",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-transparent via-[#050814]/40 to-[#050814]/70" />
        <div className="absolute inset-x-0 bottom-0 h-52 bg-gradient-to-t from-[#04070f] to-transparent" />
      </div>

      {/* fine grain texture */}
      <div
        className="absolute inset-0 opacity-[0.05] mix-blend-overlay"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='140' height='140'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0'/></filter><rect width='140' height='140' filter='url(%23n)'/></svg>\")",
        }}
      />
    </div>
  );
};

export default Background;
